module.exports = __webpack_public_path__ + "img/logo_w.d8701364.png";